<template>
  <div>
    <b-card v-if="dataList.length === 0">
      <b-row>
        <b-col
          cols="12"
          md="12"
        >
          <b-alert
            show
            variant="info"
          >
            <div class="text-center alert-body">
              <feather-icon icon="InfoIcon" />
              Ürün detay bilgisi eklenmemiş.
              <div class="mt-1">
                <b-button
                  variant="info"
                  @click="addRow"
                >
                  <feather-icon icon="PlusIcon" />
                  Ekle
                </b-button>
              </div>
            </div>
          </b-alert>
        </b-col>
      </b-row>
    </b-card>
    <b-card
      v-for="(item,index) in dataList"
      :key="index"
    >
      <b-row>
        <b-col
          cols="12"
          md="12"
        >
          <b-row>
            <b-col
              cols="12"
              md="6"
            >
              <product-items-image-card :i-key="index" />
            </b-col>
            <b-col
              cols="12"
              md="6"
            >
              <b-row>
                <b-col
                  cols="12"
                  md="12"
                >
                  <div class="text-right">
                    <b-button
                      size="sm"
                      class="btn-icon"
                      variant="flat-danger"
                      @click="removeRow(item.id,index)"
                    >
                      <feather-icon icon="TrashIcon" />
                    </b-button>
                  </div>
                </b-col>
                <b-col
                  cols="12"
                  md="12"
                >
                  <product-items-title :i-key="index" />
                </b-col>
                <b-col
                  cols="12"
                  md="12"
                >
                  <product-items-sizes :i-key="index" />
                </b-col>
                <b-col
                  v-if="item.id"
                  cols="12"
                  md="12"
                >
                  <b-button
                    class="btn-block"
                    variant="success"
                    @click="updateRow(item)"
                  >
                    <feather-icon icon="SaveIcon" />
                    Güncelle
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
    <b-row
      v-if="dataList.length > 0"
      class="mb-2"
    >
      <b-col
        cols="12"
        md="12"
      >
        <div class="text-center">
          <b-button
            variant="primary"
            @click="addRow"
          >
            <feather-icon icon="PlusIcon" /> Yeni Satır Ekle
          </b-button>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BAlert, BButton,
} from 'bootstrap-vue'
import ProductItemsImageCard from '@/views/Admin/Products/Elements/Items/ImageCard.vue'
import ProductItemsTitle from '@/views/Admin/Products/Elements/Items/Title.vue'
import ProductItemsSizes from '@/views/Admin/Products/Elements/Items/Sizes.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'ProductItemsForm',
  components: {
    ProductItemsSizes,
    ProductItemsTitle,
    ProductItemsImageCard,
    BCard,
    BRow,
    BCol,
    BAlert,
    BButton,
  },
  computed: {
    dataList() {
      return this.$store.getters['productItems/dataList']
    },
    product() {
      return this.$store.getters['products/dataItem']
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    getDataList() {
      return this.$store.dispatch('productItems/getDataList', {
        select: {
          id: true,
          title: true,
          sizes: true,
        },
        where: {
          id_products: Number(this.$route.params.id),
        },
      })
    },
    addRow() {
      this.dataList.push({
        id: null,
        title: null,
        sizes: null,
        id_products: this.product.id,
      })
    },
    updateRow(row) {
      this.$store.dispatch('productItems/saveData', row)
        .then(response => {
          if (response.status) {
            this.showToast({
              variant: 'success', title: 'İşlem Başarılı!', icon: 'CheckIcon', text: response.message,
            })
          } else {
            this.showToast({
              variant: 'danger', title: 'İşlem Hatası!', icon: 'XIcon', text: response.message,
            })
          }
        })
    },
    removeRow(id, index) {
      if (id) {
        this.$swal({
          title: this.$store.state.app.removeTitle,
          text: this.$store.state.app.removeMessage,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: this.$store.state.app.removeConfirm,
          cancelButtonText: this.$store.state.app.removeCancel,
          customClass: {
            confirmButton: 'btn btn-success',
            cancelButton: 'btn btn-danger ml-1',
          },
          buttonsStyling: false,
        }).then(result => {
          if (result.value) {
            this.$store.dispatch('productItems/removeData', id)
              .then(res => {
                if (res) {
                  this.$swal({
                    icon: 'success',
                    title: this.$store.state.app.removeResultTitle,
                    text: this.$store.state.app.removeResultMessage,
                    confirmButtonText: this.$store.state.app.removeResultClose,
                    customClass: {
                      confirmButton: 'btn btn-success',
                    },
                  })
                  this.dataList.splice(index, 1)
                } else {
                  this.$swal({
                    icon: 'error',
                    title: this.$store.state.app.removeResultTitle,
                    text: 'Silme işlemi sırasında hata oluştu.',
                    confirmButtonText: this.$store.state.app.removeResultClose,
                    customClass: {
                      confirmButton: 'btn btn-success',
                    },
                  })
                }
              })
          }
        })
      } else {
        this.dataList.splice(index, 1)
      }
    },
    showToast(params) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: params.title,
          icon: params.icon,
          text: params.text,
          variant: params.variant,
        },
      })
    },
  },
}
</script>
